import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59208864"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-icon d-f align-c justify-c" }, "!"),
  /*#__PURE__*/_createTextVNode("Tips")
], -1))
const _hoisted_2 = { class: "tc program-status" }
const _hoisted_3 = { class: "modal-content m-t-8" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  key: 0,
  class: "f-c-red"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Comment")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    wrapClassName: "modal-container",
    centered: "",
    onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', false))),
    bodyStyle: {padding: '0 40px'}
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        class: "m-l-16 min-tbn-w",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        class: "m-l-16 min-tbn-w",
        type: _ctx.status == 'rejected' && _ctx.comment.length == 0 ? '' : 'primary',
        disabled: _ctx.status == 'rejected' && _ctx.comment.length == 0,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('on-ok')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.okText), 1)
        ]),
        _: 1
      }, 8, ["type", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title) + " Batch:", 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "tc program-name",
          key: index
        }, _toDisplayString(item.batchName), 1))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          (_ctx.status === 'rejected')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
            : _createCommentVNode("", true),
          _hoisted_6
        ]),
        _createVNode(_component_a_textarea, {
          style: {"border":"none"},
          class: "textarea",
          value: _ctx.comment,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:comment', $event.target.value))),
          placeholder: `Please provide your comments for ${_ctx.status == 'rejected' ? 'rejection' : 'approve'}`,
          rows: 4
        }, null, 8, ["value", "placeholder"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}